import { useState, useEffect, useCallback } from 'react';
import SignaturePad from 'signature_pad';

function useSignaturePad() {
  const [signPad, setSignPad] = useState('');
  const [sign, setSign] = useState('');

  // useCallback para guardar la referencia al objeto SignaturePad
  const signRef = useCallback((canvas) => {
    if (canvas) {
      const sigPadInstance = new SignaturePad(canvas);
      setSignPad(sigPadInstance);
    }
  }, []);

  // Evento que se ejecuta cuando termina de dibujar
  const onStrokeEnd = useCallback(() => {
    if (signPad) {
      // console.log(signPad.toDataURL());
      setSign(signPad.toDataURL());
    }
  }, [signPad]);

  useEffect(() => {
    if (signPad) {
      signPad.addEventListener('endStroke', onStrokeEnd);
    }

    // Cleanup: remover el evento cuando el componente se desmonta
    return () => {
      if (signPad) {
        signPad.removeEventListener('endStroke', onStrokeEnd);
      }
    };
  }, [signPad, onStrokeEnd]);

  return {
    signRef,
    setSignPad,
    signPad,
    sign,
  };
}

export default useSignaturePad;
